export enum BotHeaderTabType {
  StepNlpModel = 'StepNlpModel',
  NlpModel = 'NlpModel',
  Dialog = 'Dialog',
  NlpTraining = 'NlpTraining',
  NlpChatQueries = 'NlpChatQueries',
  KnowledgeBase = 'KnowledgeBase'
}

export type BotHeaderTab = {
  type: BotHeaderTabType
  id?: string
  title?: string
}
